import { openDB } from "idb";

const DB_NAME = "JsonItems";
const STORE_NAME = "items";
const DB_VERSION = 1;

export const initDB = async () => {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
            }
        },
    });
};

export const addItemToDB = async (item) => {
    const db = await initDB();
    await db.add(STORE_NAME, item);
};

export const getAllItemsFromDB = async () => {
    const db = await initDB();
    return db.getAll(STORE_NAME);
};

export const removeItemFromDB = async (id) => {
    const db = await initDB();
    await db.delete(STORE_NAME, id);
};

export const clearAllFromDB = async () => {
    const db = await initDB();
    await db.clear(STORE_NAME);
};

export const updateItemFromDB = async (item) => {
    const db = await initDB();
    await db.put(STORE_NAME, item);
};

export const getItemByIdFromDB = async (id) => {
    const db = await initDB();
    return db.get(STORE_NAME, id);
};


export const updateItem = async (item) => {
    const db = await initDB();
    return db.get(STORE_NAME, item);
};